exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cash-variances-search-section {\n  display: flex;\n  justify-content: center; }\n\n.cash-variances-line-section {\n  margin-top: 10px !important;\n  margin-bottom: 5px !important; }\n\n.variance-actions {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px;\n  flex-wrap: nowrap;\n  overflow: visible; }\n\n.variance-actions .btn-link {\n  padding: 0;\n  margin: 0; }\n\n.variance-actions .btn-xs.btn-primary {\n  margin: 0; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/branch_management/components/count_variances/count_variances.scss
// module id = 984
// module chunks = 1